import {cn} from '../../lib/utils';

import type {ComponentProps} from 'react';

export interface DotProps extends ComponentProps<'span'> {
  colorClassName?: string;
  /** `sm` — a 6px dot centred in the 8px box. `md` — the dot fills the whole 8px box, so a ring stays inside it. */
  size?: 'sm' | 'md';
  /** Thin 1px ring in a darker shade of the fill, drawn inside the dot so pale fills stay visible on white. */
  ring?: boolean;
}

// Inner circle is absolutely positioned — guarantees a true square box regardless of layout context.
export const Dot = ({
  className,
  colorClassName = 'bg-current',
  size = 'sm',
  ring = false,
  ...props
}: DotProps) => {
  return (
    <span
      data-slot="dot"
      className={cn('relative inline-block size-2 shrink-0', className)}
      {...props}
    >
      <span
        className={cn(
          'absolute rounded-full',
          size === 'md' ? 'inset-0' : 'inset-px',
          ring && 'ring-1 ring-inset ring-fg/15',
          colorClassName
        )}
      />
    </span>
  );
};
